import { useEffect, useState } from "react";
import useUserRole from "./useUserRole";
import useUserAccess from "./useUserAccess";

export const useAuth = () => {
  const [user, setUser] = useState<any | null>(null);
  const [accessModules, setAccessModules] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const { userRole, isDataLoading: isRoleLoading } = useUserRole();
  const { userAccess, isDataLoading: isAccessLoading } = useUserAccess();
  

  useEffect(() => {
    if (isRoleLoading || isAccessLoading) return;
    const loadAuthData = () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData") || "null");

        if (!userData) {
          setUser(null);
          setAccessModules(null);
          return;
        }

        const { roleId, userType } = userData;

        setUser(userData);
        if (userType === "SUPER_ADMIN") {
          setAccessModules({
            modules: userAccess || [],
          });
        } else if (userRole && roleId) {
          const matchedRole =
            userRole.find((role) => role._id === roleId) || null;
          setAccessModules(matchedRole);
        }
      } catch (error) {
        console.error("Failed to load auth data", error);
        setUser(null);
        setAccessModules(null);
      } finally {
        setIsLoading(false);
      }
    };
    loadAuthData();
  }, [userRole, userAccess, isAccessLoading, isRoleLoading]);

  const hasModuleAccess = (moduleId: string) => {
    return (
      accessModules?.modules?.some((m: any) => m?.moduleId === moduleId) ||
      false
    );
  };
  const hasActionPermission = (moduleId: string, actionId: string) => {
    const module = accessModules?.modules?.find(
      (m: any) => m?.moduleId === moduleId
    );
    return (
      module?.moduleAction?.some((a: any) => a?.actionId === actionId) || false
    );
  };

  const getAvailableModules = () => {
    return accessModules?.modules || [];
  };

  return {
    user,
    accessModules,
    isLoading: isLoading || isRoleLoading || isAccessLoading,
    isAuthenticated: !!user,
    hasModuleAccess,
    hasActionPermission,
    getAvailableModules,
  };
};
